import { Usp } from "@omni/types/components/product/productPage/usps.type";
import { isDefined } from "@omni/utils/helper.utils";
import { createContext, ReactNode, use } from "react";

type UspsContextValue = {
    usps: Array<Usp>;
};

type UspsContextProviderProps = {
    usps: Array<Usp>;
    children: ReactNode;
};

export const UspsContext = createContext<UspsContextValue | undefined>(
    undefined
);

export const UspsContextProvider = ({
    usps,
    children
}: UspsContextProviderProps) => {
    return (
        <UspsContext
            value={{
                usps: usps
            }}
        >
            {children}
        </UspsContext>
    );
};

export const useUspsContext = () => {
    const context = use<UspsContextValue | undefined>(UspsContext);

    if (!isDefined(context)) {
        throw new Error(`${UspsContext.displayName} is undefined.`);
    }

    return context;
};
